// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A4U8).
// Welcome, step two: the first organization, on the welcome steps' card (A13U1, board getin-org).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { CreateOrg } from '../../features/onboarding/CreateOrg'
import { OnboardingFrame } from '../../features/onboarding/OnboardingFrame'

export const Route = createFileRoute('/welcome/')({
  staticData: {
    screenId: 'OnboardingCreateOrgScreen',
    access: 'verified, no organization (also reachable from MeHome)',
  },
  component: OnboardingCreateOrgScreen,
})

function OnboardingCreateOrgScreen() {
  const { t } = useTranslation()
  return (
    <OnboardingFrame
      testId={ids.onboardingCreateOrg.root}
      step={2}
      title={t('onboarding.create.title')}
      lead={t('onboarding.create.lead')}
      accountTestId={ids.onboardingCreateOrg.accountButton}
    >
      <CreateOrg />
    </OnboardingFrame>
  )
}
